export enum INGRESS_TYPE {
	OIDC = 'oidc',
	JWT = 'jwt',
	WSTRUST = 'wstrust',
}
